"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogPanel = void 0;
const vue_1 = require("vue");
const CardType_1 = require("../cards/CardType");
const LogMessageType_1 = require("../LogMessageType");
const LogMessageDataType_1 = require("../LogMessageDataType");
const Card_1 = require("./card/Card");
const i18n_1 = require("../directives/i18n");
const CardFinder_1 = require("./../CardFinder");
const TileType_1 = require("../TileType");
const utils_1 = require("../utils/utils");
const SoundManager_1 = require("./SoundManager");
const PreferencesManager_1 = require("./PreferencesManager");
const GlobalEvent_1 = require("./GlobalEvent");
const GlobalEventDealer_1 = require("../turmoil/globalEvents/GlobalEventDealer");
const PartyName_1 = require("../turmoil/parties/PartyName");
const Log_1 = require("../Log");
const Colony_1 = require("./Colony");
let logRequest;
exports.LogPanel = vue_1.default.component('log-panel', {
    props: {
        id: {
            type: String,
        },
        generation: {
            type: Number,
        },
        lastSoloGeneration: {
            type: Number,
        },
        players: {
            type: Array,
        },
        color: {
            type: String,
        },
    },
    data: function () {
        return {
            cards: [],
            colonyNames: [],
            globalEventNames: [],
            messages: [],
            selectedGeneration: this.generation,
            copiedUrl: null,
        };
    },
    components: {
        Card: Card_1.Card,
        Colony: Colony_1.Colony,
        GlobalEvent: GlobalEvent_1.GlobalEvent,
    },
    methods: {
        scrollToEnd: function () {
            const scrollablePanel = document.getElementById('logpanel-scrollable');
            if (scrollablePanel !== null) {
                scrollablePanel.scrollTop = scrollablePanel.scrollHeight;
            }
        },
        cardToHtml: function (cardType, cardName) {
            const cardNameString = i18n_1.$t(cardName);
            const suffixFreeCardName = cardNameString.split(':')[0];
            let className;
            if (cardType === CardType_1.CardType.EVENT) {
                className = 'background-color-events';
            }
            else if (cardType === CardType_1.CardType.ACTIVE) {
                className = 'background-color-active';
            }
            else if (cardType === CardType_1.CardType.AUTOMATED) {
                className = 'background-color-automated';
            }
            else if (cardType === CardType_1.CardType.PRELUDE) {
                className = 'background-color-prelude';
            }
            else if (cardType === CardType_1.CardType.STANDARD_PROJECT || cardType === CardType_1.CardType.STANDARD_ACTION) {
                className = 'background-color-standard-project';
            }
            else if (cardType === CardType_1.CardType.LEADER) {
                className = 'background-color-leader';
            }
            if (className === undefined) {
                return suffixFreeCardName;
            }
            return '<span class="log-card ' + className + '">' + suffixFreeCardName + '</span>';
        },
        messageDataToHTML: function (data) {
            const translatableMessageDataTypes = [
                LogMessageDataType_1.LogMessageDataType.STRING,
                LogMessageDataType_1.LogMessageDataType.STANDARD_PROJECT,
                LogMessageDataType_1.LogMessageDataType.MILESTONE,
                LogMessageDataType_1.LogMessageDataType.AWARD,
                LogMessageDataType_1.LogMessageDataType.COLONY,
                LogMessageDataType_1.LogMessageDataType.PARTY,
                LogMessageDataType_1.LogMessageDataType.TILE_TYPE,
                LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT,
            ];
            if (data.type === undefined || data.value === undefined) {
                return '';
            }
            switch (data.type) {
                case LogMessageDataType_1.LogMessageDataType.PLAYER:
                    for (const player of this.players) {
                        if (data.value === player.color || data.value === player.id) {
                            return '<span class="log-player player_bg_color_' + player.color + '">' + player.name + '</span>';
                        }
                    }
                    break;
                case LogMessageDataType_1.LogMessageDataType.CARD:
                    const cardName = data.value;
                    const card = new CardFinder_1.CardFinder().getCardByName(cardName, (manifest) => [
                        manifest.corporationCards,
                        manifest.projectCards,
                        manifest.preludeCards,
                        manifest.standardProjects,
                        manifest.standardActions,
                        manifest.turmoilActions,
                        manifest.leaderCards,
                    ]);
                    for (const player of this.players) {
                        if ((card === null || card === void 0 ? void 0 : card.cardType) === CardType_1.CardType.CORPORATION) {
                            return '<span class="log-card background-color-corporation">' + i18n_1.$t(cardName) + '</span>';
                        }
                        else {
                            const robotCards = player.playedCards.concat(player.selfReplicatingRobotsCards);
                            for (const robotCard of robotCards) {
                                if (cardName === robotCard.name && robotCard.cardType !== undefined) {
                                    return this.cardToHtml(robotCard.cardType, cardName);
                                }
                            }
                        }
                    }
                    if (card && card.cardType)
                        return this.cardToHtml(card.cardType, data.value);
                    break;
                case LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT:
                    const globalEventName = data.value;
                    return '<span class="log-card background-color-global-event">' + i18n_1.$t(globalEventName) + '</span>';
                case LogMessageDataType_1.LogMessageDataType.COLONY:
                    const colonyName = data.value;
                    return '<span class="log-card background-color-colony">' + i18n_1.$t(colonyName) + '</span>';
                case LogMessageDataType_1.LogMessageDataType.TILE_TYPE:
                    const tileType = +data.value;
                    return i18n_1.$t(TileType_1.TileType.toString(tileType));
                default:
                    if (translatableMessageDataTypes.includes(data.type)) {
                        return i18n_1.$t(data.value);
                    }
            }
            return data.value;
        },
        safeMessage: function (message) {
            try {
                if (message === undefined) {
                    return 'undefined';
                }
                if (message.data === undefined) {
                    return `BUG: Unparseable message: ${message.message}`;
                }
                const data = message.data.map((datum) => {
                    return (datum === undefined) ?
                        'undefined' :
                        ('(' + datum.type + ') ' + datum.value);
                });
                return `BUG: Unparseable message: ${message.message}, (${data.join(', ')})`;
            }
            catch (err) {
                return `BUG: Unparseable message: ${message.message} ${err}`;
            }
        },
        messageToHTML: function (message) {
            try {
                let logEntryBullet = '';
                if (message.type !== LogMessageType_1.LogMessageType.NEW_GENERATION) {
                    const when = new Date(message.timestamp).toLocaleString();
                    const icon = message.playerId === undefined ? '&#x1f551;' : '&#x1f4ac;';
                    logEntryBullet = `<span title="${when}">${icon}</span>`;
                }
                if (message.type !== undefined && message.message !== undefined) {
                    message.message = i18n_1.$t(message.message);
                    return logEntryBullet + Log_1.Log.applyData(message, this.messageDataToHTML);
                }
            }
            catch (err) {
                return this.safeMessage(message);
            }
            return '';
        },
        messageToPlainText: function (message) {
            try {
                if (message.type !== undefined && message.message !== undefined) {
                    const parsedMessage = message.message.replace(/\$\{(\d{1,2})\}/gi, (_match, idx) => {
                        return this.messageDataToHTML(message.data[idx]).replace(/<(.|\n)*?>/g, '');
                    });
                    if (message.playerId !== undefined)
                        return '(' + parsedMessage + ')';
                    return parsedMessage;
                }
            }
            catch (err) {
                return this.safeMessage(message);
            }
            return '';
        },
        messageClicked: function (message) {
            const datas = message.data;
            datas.forEach((data) => {
                if (data.value === undefined)
                    return;
                if (data.type === LogMessageDataType_1.LogMessageDataType.CARD) {
                    const cardName = data.value;
                    const index = this.cards.indexOf(cardName);
                    if (index === -1) {
                        this.cards.push(cardName);
                    }
                    else {
                        this.cards.splice(index, 1);
                    }
                }
                if (data.type === LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT) {
                    const globalEventName = data.value;
                    const index = this.globalEventNames.indexOf(globalEventName);
                    if (index === -1) {
                        this.globalEventNames.push(globalEventName);
                    }
                    else {
                        this.globalEventNames.splice(index, 1);
                    }
                }
                if (data.type === LogMessageDataType_1.LogMessageDataType.COLONY) {
                    const colonyName = data.value;
                    const index = this.colonyNames.indexOf(colonyName);
                    if (index === -1) {
                        this.colonyNames.push(colonyName);
                    }
                    else {
                        this.colonyNames.splice(index, 1);
                    }
                }
            });
        },
        hideMe: function () {
            this.cards = [];
            this.colonyNames = [];
            this.globalEventNames = [];
        },
        getCrossHtml: function () {
            return '<i class=\'icon icon-cross\' />';
        },
        selectGeneration: function (gen) {
            if (gen !== this.selectedGeneration) {
                this.getLogsForGeneration(gen);
            }
            this.selectedGeneration = gen;
        },
        downloadLog: function () {
            var _a;
            const messages = this.messages;
            if (logRequest !== undefined) {
                logRequest.abort();
                logRequest = undefined;
            }
            const xhr = new XMLHttpRequest();
            logRequest = xhr;
            xhr.open('GET', `/api/game/logs?id=${(_a = this.players[0].spectatorId) !== null && _a !== void 0 ? _a : this.id}&generation=${0}`);
            xhr.onerror = () => {
                console.error('error updating messages, unable to reach server');
            };
            xhr.onload = () => {
                if (xhr.status === 200) {
                    messages.splice(0, messages.length);
                    messages.push(...xhr.response);
                    const allMessages = xhr.response;
                    let plainifiedLog = '';
                    allMessages.forEach((message) => {
                        plainifiedLog += this.messageToPlainText(message) + '\n';
                    });
                    const blob = new Blob([plainifiedLog], { type: 'text/plain' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const dateFormat = require('dateformat');
                    const date = dateFormat(new Date(), 'isoDateTime');
                    link.download = 'game-log' + date;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                else {
                    console.error(`error updating messages, response code ${xhr.status}`);
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        getLogsForGeneration: function (generation) {
            const messages = this.messages;
            if (logRequest !== undefined) {
                logRequest.abort();
                logRequest = undefined;
            }
            const xhr = new XMLHttpRequest();
            logRequest = xhr;
            xhr.open('GET', `/api/game/logs?id=${this.id}&generation=${generation}`);
            xhr.onerror = () => {
                console.error('error updating messages, unable to reach server');
            };
            xhr.onload = () => {
                if (xhr.status === 200) {
                    messages.splice(0, messages.length);
                    messages.push(...xhr.response);
                    if (PreferencesManager_1.PreferencesManager.loadBoolean('enable_sounds') && window.location.search.includes('experimental=1')) {
                        SoundManager_1.SoundManager.newLog();
                    }
                    if (generation === this.generation) {
                        this.$nextTick(this.scrollToEnd);
                    }
                }
                else {
                    console.error(`error updating messages, response code ${xhr.status}`);
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        getClassesGenIndicator: function (gen) {
            const classes = ['log-gen-indicator'];
            if (gen === this.selectedGeneration) {
                classes.push('log-gen-indicator--selected');
            }
            return classes.join(' ');
        },
        getGenerationsRange: function () {
            const generations = [];
            for (let i = 1; i <= this.generation; i++) {
                generations.push(i);
            }
            return generations;
        },
        getTitleClasses: function () {
            const classes = ['log-title'];
            classes.push(utils_1.playerColorClass(this.color.toLowerCase(), 'shadow'));
            return classes.join(' ');
        },
        lastGenerationClass: function () {
            return this.lastSoloGeneration === this.generation ? 'last-generation blink-animation' : '';
        },
        getGlobalEvent: function (globalEventName) {
            const globalEvent = GlobalEventDealer_1.getGlobalEventByName(globalEventName);
            if (globalEvent !== undefined) {
                return {
                    name: globalEvent.name,
                    description: globalEvent.description,
                    revealed: globalEvent.revealedDelegate,
                    current: globalEvent.currentDelegate,
                };
            }
            return {
                name: globalEventName,
                description: 'global event not found',
                revealed: PartyName_1.PartyName.GREENS,
                current: PartyName_1.PartyName.GREENS,
            };
        },
        getColony: function (colonyName) {
            return {
                colonies: [],
                isActive: false,
                name: colonyName,
                trackPosition: 0,
                visitor: undefined,
                details: [],
            };
        },
        getResourcesOnCard(cardName) {
            for (const player of this.players) {
                const foundCard = player.playedCards.find((card) => card.name === cardName);
                if (foundCard !== undefined)
                    return foundCard.resources;
            }
            return undefined;
        },
        copyPlayerLink: function () {
            const url = window.location.href;
            const input = document.createElement('input');
            this.copiedUrl = url;
            input.setAttribute('value', url);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        isUrlCopied: function () {
            return this.copiedUrl !== null;
        },
        clearCopiedUrl: function () {
            this.copiedUrl = null;
        },
    },
    mounted: function () {
        this.getLogsForGeneration(this.generation);
        for (const player of this.players) {
            if (player.actionsTakenThisGame > 0)
                return;
        }
    },
    template: `
      <div class="log-container">
        <div class="log-generations">
          <h2 :class="getTitleClasses()">
              <span v-i18n>Game log</span>
          </h2>
          <div class="log-gen-title">Gen: </div>
          <div class="log-gen-numbers">
            <div v-for="n in getGenerationsRange()" :class="getClassesGenIndicator(n)" v-on:click.prevent="selectGeneration(n)">
              {{ n }}
            </div>
          </div>
          <span class="label-additional" v-if="players.length === 1"><span :class="lastGenerationClass">of {{this.lastSoloGeneration}}</span></span>

          <span>
            <Button title="Copy Link" size="big" class="copy-link-button" :onClick="_=>copyPlayerLink()"/>
          </span>

          <span>
            <Button title="💾 Save Log" size="big" class="save-log-button" :onClick="_=>downloadLog()"/>
          </span>

          <span v-if="isUrlCopied()" class="copied-notice">Link copied to clipboard! <span class="dismissed" @click="clearCopiedUrl" >dismiss</span></span>
        </div>
        <div class="panel log-panel">
          <div id="logpanel-scrollable" class="panel-body">
            <ul v-if="messages">
            <li v-for="message in messages" v-on:click.prevent="messageClicked(message)" v-html="messageToHTML(message)"></li>
            </ul>
          </div>
        </div>
        <div class="card-panel" v-if="cards.length + globalEventNames.length + colonyNames.length > 0">
          <Button size="big" type="close" :disableOnServerBusy="false" :onClick="hideMe" align="right"/>
          <div id="log_panel_card" class="cardbox" v-for="(card, index) in cards" :key="card">
            <Card :card="{name: card, resources: getResourcesOnCard(card)}"/>
          </div>
          <div id="log_panel_card" class="cardbox" v-for="(globalEventName, index) in globalEventNames" :key="globalEventName">
            <global-event :globalEvent="getGlobalEvent(globalEventName)" type="prior"></global-event>
          </div>
          <div id="log_panel_card" class="cardbox" v-for="(colonyName, index) in colonyNames" :key="colonyName">
            <colony :colony="getColony(colonyName)"></colony>
          </div>
        </div>
      </div>
    `,
});
//# sourceMappingURL=LogPanel.js.map